import { memo } from 'react';
import FormSectionHeader from '../common/FormSectionHeader';
import { withStyles } from '@material-ui/core';
import styles from '../EditReasonInfo/styles';
import { TextFieldWithLabel } from '../components/TextField';
import appConstant from '../../../../../../../appConstants';
import { DateTimeEditorWithLabel } from '../components/DateTimeEditor';
import { convertDateTimeToTimeString, isTimeValid } from '@dataGrid/gridUtilities';
import { MAX_LENGTH_CONSTRAINTS } from '../constants';
import { getFieldError } from './utils';
const NoFreightInfo = ({ classes, noFreightPickupData, updateNoFreightPickup }) => {
  const handleChange = (field) => (value) => {
    if (field === 'callTime') {
      if (value && !isTimeValid(convertDateTimeToTimeString(value))) {
        return;
      }
    }
    updateNoFreightPickup({
      ...noFreightPickupData,
      [field]: value,
      errorInfo: {
        ...noFreightPickupData.errorInfo,
        [field]: getFieldError(field, value)
      },
      ...(field === 'comments' && { commentCount: value.length })
    });
  };
  const MAX_COMMENT_LENGTH = MAX_LENGTH_CONSTRAINTS.VOID_PICKUP_FORM.COMMENT;
  return (
    <>
      <FormSectionHeader label="No Freight Info" />
      <div className={classes.formContainer} id="noFreightPickup">
        <div className={classes.inputFieldWrapper}>
          <TextFieldWithLabel
            label="Contact Name :"
            id="contactName"
            handleChange={handleChange('contactName')}
            error={noFreightPickupData.errorInfo.contactName}
            value={noFreightPickupData.contactName}
            inputClass={classes.contactName}
          />
          <DateTimeEditorWithLabel
            label="Call Time :"
            id="callTime"
            dateType={appConstant.DATETYPES.TIME}
            inputClass={classes.timeInput}
            value={convertDateTimeToTimeString(noFreightPickupData.callTime)}
            onChange={handleChange('callTime')}
            disableFocusInput
            enablePickerPortal
            errorText={noFreightPickupData.errorInfo.callTime ?? ''}
          />
          <div className={classes.commentsWrapper}>
            <TextFieldWithLabel
              label="Comments :"
              id="comments"
              labelClass={classes.NoFreightCommentsLabel}
              handleChange={handleChange('comments')}
              error={noFreightPickupData.errorInfo.comments}
              value={noFreightPickupData.comments}
              inputClass={classes.comments}
              multiline
              rows={3}
              inputProps={{
                maxLength: MAX_COMMENT_LENGTH
              }}
              helperText={`${noFreightPickupData.commentCount ?? 0}/${MAX_COMMENT_LENGTH}`}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default withStyles(styles)(memo(NoFreightInfo));
